import { Button, } from '@mui/material';

import classes from './button.module.scss';

export const CustomButton = ({ handleDo, children, active, }) => (<Button onClick={handleDo} className={active ? classes.activeBtn : classes.customBtn}>{children}</Button>);

export const WideButton = ({ children, active, ...props }) => (<Button {...props} className={classes.WideButton}>{children}</Button>);
